import React, { useState, useEffect } from 'react';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import baseUrl from '../BaseUrl';
import Loader from '../Loader';
import Pagination from 'react-js-pagination';

const RegistrationDetails = ({ token, expire, setToken, setExpire, setName, selectedCid, allEmails }) => {
    const [details,    setDetails]    = useState([]);
    const [totalItem,  setTotalItem]  = useState(0);
    const [page,       setPage]       = useState(1);
    const [showAll,    setShowAll]    = useState(false);
    const [form,       setForm]       = useState(null);
    const [formErrors, setFormErrors] = useState({});
    const [popupOpen,  setPopupOpen]  = useState(true);
    const [msg,        setMsg]        = useState('');
    const [isSuccess,  setIsSuccess]  = useState(false);
    const [expandedTNs, setExpandedTNs] = useState({});
    const [confirmModal, setConfirmModal] = useState(null);

    useEffect(() => { if (token && selectedCid) loadDetails(); }, [token, selectedCid, page, showAll]);

    const axiosJWT = axios.create();
    axiosJWT.interceptors.request.use(async (config) => {
        if (expire * 1000 < Date.now()) {
            const res = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${res.data.accessToken}`;
            setToken(res.data.accessToken);
            const decoded = jwt_decode(res.data.accessToken);
            setName(decoded.name); setExpire(decoded.exp);
        }
        return config;
    }, err => Promise.reject(err));

    const showMsg = (text, success = true) => { setMsg(text); setIsSuccess(success); };

    const loadDetails = async (pg) => {
        setPopupOpen(true);
        try {
            const currentPage = pg !== undefined ? pg : page;
            const res = await axiosJWT.get(
                `${baseUrl}/registration/setup/details?cid=${selectedCid}&page=${currentPage}&limit=20&show_all=${showAll}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setDetails(res.data.data); setTotalItem(res.data.totalItem);
            if (pg !== undefined) setPage(pg);
        } catch (e) { console.log(e); }
        setPopupOpen(false);
    };

    const loadTNs = async (detailsId) => {
        if (expandedTNs[detailsId]) { setExpandedTNs(prev => ({ ...prev, [detailsId]: null })); return; }
        try {
            const res = await axiosJWT.get(`${baseUrl}/registration/setup/details/${detailsId}/tns`, { headers: { Authorization: `Bearer ${token}` } });
            setExpandedTNs(prev => ({ ...prev, [detailsId]: res.data.data }));
        } catch (e) { console.log(e); }
    };

    const handleSave = async (action) => {
        const errs = {};
        if (!form.registration_short_description?.trim()) errs.desc = 'Short description required.';
        if (!form.customer_registration_name?.trim()) errs.name = 'Registration name required.';
        setFormErrors(errs);
        if (Object.keys(errs).length > 0) return;

        if (form.id && !action) { setConfirmModal({ type: 'edit' }); return; }

        setPopupOpen(true);
        try {
            const res = await axiosJWT.post(`${baseUrl}/registration/setup/details/save`,
                { ...form, bap_bbd_id: selectedCid, action: action || null },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            showMsg(res.data.msg); setForm(null); setConfirmModal(null);
            setPopupOpen(false);
            await loadDetails(1);
        } catch (e) {
            showMsg(e.response?.data?.msg || 'Error saving.', false);
            setPopupOpen(false);
        }
    };

    const handleReactivate = async (id) => {
        if (!window.confirm('Reactivate this Registration Details?\n\nTN associations that were deactivated with this record will be restored, provided their linked Registration Language is also active.')) return;
        try {
            setPopupOpen(true);
            const res = await axiosJWT.post(`${baseUrl}/registration/setup/details/reactivate/${id}`, {}, { headers: { Authorization: `Bearer ${token}` } });
            showMsg(res.data.msg); loadDetails();
        } catch (e) { showMsg(e.response?.data?.msg || 'Error reactivating.', false); }
        setPopupOpen(false);
    };

    const handleDeactivate = async (id) => {
        if (!window.confirm('By selecting that the Registration Details is no longer active, all associated TN will be deactivated.\n\nConfirm YES?')) return;
        try {
            setPopupOpen(true);
            const res = await axiosJWT.post(`${baseUrl}/registration/setup/details/deactivate/${id}`, {}, { headers: { Authorization: `Bearer ${token}` } });
            showMsg(res.data.msg); loadDetails();
        } catch (e) { showMsg(e.response?.data?.msg || 'Error deactivating.', false); }
        setPopupOpen(false);
    };

    const emptyForm = {
        registration_short_description: '', customer_registration_name: '',
        customer_website: '', customer_contact_name: '', customer_email_address: '',
        calling_type: '', dials: '', registration_email_address_id: '',
        available_for_use_start_date: ''
    };

    return (
        <div>
            {popupOpen && <Loader />}
            <p className={`has-text-centered ${isSuccess ? 'success' : 'error'}`}>{msg}</p>

            {confirmModal?.type === 'edit' && (
                <div className="modal-overlay" style={{ position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center' }}>
                    <div style={{ background:'#fff',padding:'30px',borderRadius:'8px',maxWidth:'500px',width:'90%' }}>
                        <h4>Confirm Update</h4>
                        <p>Please confirm that all TN listed are to be updated to have the new Registration Details.</p>
                        <div style={{ display:'flex',gap:'10px',marginTop:'15px',flexWrap:'wrap' }}>
                            <button className="btn btn-primary" onClick={() => handleSave('confirm')}>CONFIRM</button>
                            <button className="btn btn-warning" onClick={() => handleSave('new')}>MAKE NEW ENTRY WITH NO TN ASSOCIATED</button>
                            <button className="btn btn-secondary" onClick={() => { setConfirmModal(null); handleSave('discard'); }}>DISCARD CHANGES</button>
                        </div>
                    </div>
                </div>
            )}

            <div className="col-12 common-white-shadow-background setting-section">
                <div className="row">
                    <div className="col-6">
                        <label>
                            <input type="checkbox" style={{ width:'auto' }} checked={showAll} onChange={e => { setShowAll(e.target.checked); setPage(1); }} /> Include Inactive Records
                        </label>
                    </div>
                    <div className="col-6 inventory-btn">
                        {!form && (
                            <div className="addnew-button">
                                <a href="#" onClick={e => { e.preventDefault(); setForm({ ...emptyForm }); setFormErrors({}); }}>Add</a>
                            </div>
                        )}
                    </div>
                </div>

                {form && (
                    <div style={{ padding:'15px',background:'#f9f9f9',borderRadius:'6px',marginBottom:'15px' }}>
                        <h4>{form.id ? 'Edit Details' : 'Add Details'}</h4>
                        <div className="row">
                            <div className="col-md-3">
                                <label>Short Description * (100 chars)</label>
                                <input type="text" className="form-control" maxLength={100} value={form.registration_short_description} onChange={e => setForm({...form, registration_short_description: e.target.value})} />
                                {formErrors.desc && <div className="error error-message">{formErrors.desc}</div>}
                            </div>
                            <div className="col-md-3">
                                <label>Customer Registration Name *</label>
                                <input type="text" className="form-control" value={form.customer_registration_name} onChange={e => setForm({...form, customer_registration_name: e.target.value})} />
                                {formErrors.name && <div className="error error-message">{formErrors.name}</div>}
                            </div>
                            <div className="col-md-3">
                                <label>Customer Website</label>
                                <input type="text" className="form-control" value={form.customer_website || ''} onChange={e => setForm({...form, customer_website: e.target.value})} />
                            </div>
                            <div className="col-md-3">
                                <label>Contact Name</label>
                                <input type="text" className="form-control" value={form.customer_contact_name || ''} onChange={e => setForm({...form, customer_contact_name: e.target.value})} />
                            </div>
                        </div>
                        <div className="row" style={{ marginTop:'10px' }}>
                            <div className="col-md-3">
                                <label>Contact Email</label>
                                <input type="email" className="form-control" value={form.customer_email_address || ''} onChange={e => setForm({...form, customer_email_address: e.target.value})} />
                            </div>
                            <div className="col-md-3">
                                <label>Calling Type</label>
                                <input type="text" className="form-control" value={form.calling_type || ''} onChange={e => setForm({...form, calling_type: e.target.value})} placeholder="e.g. Marketing, Alerts" />
                            </div>
                            <div className="col-md-2">
                                <label>Dials (monthly)</label>
                                <input type="number" className="form-control" value={form.dials || ''} onChange={e => setForm({...form, dials: e.target.value})} />
                            </div>
                            <div className="col-md-4">
                                <label>Registration Email Address</label>
                                <select className="form-control" value={form.registration_email_address_id || ''} onChange={e => setForm({...form, registration_email_address_id: e.target.value})}>
                                    <option value="">— None —</option>
                                    {(allEmails || []).map(em => <option key={em.registration_email_address_id} value={em.registration_email_address_id}>{em.registration_email_address}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="row" style={{ marginTop:'10px' }}>
                            <div className="col-md-3">
                                <label>Available From Date</label>
                                <input type="date" className="form-control" value={form.available_for_use_start_date || ''} onChange={e => setForm({...form, available_for_use_start_date: e.target.value})} />
                            </div>
                        </div>
                        <div style={{ marginTop:'10px', display:'flex', gap:'10px' }}>
                            <button className="btn btn-primary" onClick={() => handleSave(null)}>Save</button>
                            <button className="btn btn-secondary" onClick={() => setForm(null)}>Cancel</button>
                        </div>
                    </div>
                )}

                <div className="fullwidth-table track-table-body">
                    <table>
                        <thead>
                            <tr><th style={{ width:'auto' }}>ID</th><th style={{ width:'auto' }}>Short Desc</th><th style={{ width:'auto' }}>Reg Name</th><th style={{ width:'auto' }}>Calling Type</th><th style={{ width:'auto' }}>Status</th><th style={{ width:'auto' }}>TNs</th><th style={{ width:'auto' }}>Actions</th></tr>
                        </thead>
                        <tbody>
                            {details.map((row, i) => (
                                <React.Fragment key={i}>
                                    <tr>
                                        <td style={{ textAlign:'left' }}>{row.reg_details_id}</td>
                                        <td style={{ textAlign:'left' }}>{row.registration_short_description}</td>
                                        <td style={{ textAlign:'left' }}>{row.customer_registration_name}</td>
                                        <td style={{ textAlign:'left' }}>{row.calling_type || '—'}</td>
                                        <td style={{ textAlign:'left', paddingLeft:0 }}><div style={{ maxWidth:'80px' }}>{row.available_for_use_end_date ? <a href="#" className="false">False</a> : <a href="#" className="true">True</a>}</div></td>
                                        <td style={{ textAlign:'left' }}>
                                            <a href="#" onClick={e => { e.preventDefault(); loadTNs(row.reg_details_id); }}>
                                                {[row.all_tn_count > 0 ? 'All TNs' : null, row.tn_count > 0 ? `${row.tn_count} TN(s)` : null, row.tag_count > 0 ? `${row.tag_count} Tag(s)` : null].filter(Boolean).join(', ') || '0'} {expandedTNs[row.reg_details_id] ? '▲' : '▼'}
                                            </a>
                                        </td>
                                        <td style={{ textAlign:'left' }}>
                                            <a href="#" onClick={e => { e.preventDefault(); setForm({ ...row, id: row.reg_details_id, available_for_use_start_date: row.available_for_use_start_date ? row.available_for_use_start_date.split('T')[0] : '' }); setFormErrors({}); }}>
                                                <img src={`${process.env.PUBLIC_URL}/images/bx-edit.png`} alt="Edit" />
                                            </a>
                                            {!row.available_for_use_end_date ? (
                                                <a href="#" style={{ marginLeft:'8px' }} onClick={e => { e.preventDefault(); handleDeactivate(row.reg_details_id); }}>
                                                    <img src={`${process.env.PUBLIC_URL}/images/bx-x-circle.png`} alt="Deactivate" title="Deactivate" />
                                                </a>
                                            ) : (
                                                <a href="#" style={{ marginLeft:'8px' }} onClick={e => { e.preventDefault(); handleReactivate(row.reg_details_id); }}>
                                                    <img src={`${process.env.PUBLIC_URL}/images/success.png`} alt="Reactivate" title="Reactivate" />
                                                </a>
                                            )}
                                        </td>
                                    </tr>
                                    {expandedTNs[row.reg_details_id] && (
                                        <tr>
                                            <td colSpan={7} style={{ background:'#f5f5f5',padding:'10px' }}>
                                                {expandedTNs[row.reg_details_id].length === 0
                                                    ? <em>No TN associations.</em>
                                                    : <table style={{ width:'100%' }}>
                                                        <thead><tr><th>TN</th><th>Tag</th><th>Language</th></tr></thead>
                                                        <tbody>
                                                            {expandedTNs[row.reg_details_id].map((t, j) => (
                                                                <tr key={j}><td>{t.tn || '—'}</td><td>{t.tag || '—'}</td><td>{t.lang_description}</td></tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                }
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                    {totalItem > 20 && <Pagination activePage={page} itemsCountPerPage={20} totalItemsCount={totalItem} pageRangeDisplayed={5} onChange={setPage} />}
                </div>
            </div>
        </div>
    );
};

export default RegistrationDetails;
